import React from 'react'
import { required, SelectInput } from 'react-admin'
import { locationFeatureCategoryChoices } from 'services/cfg/form'
import CatalogItemBaseForm, {
  CatalogItemBaseFormProps,
} from 'ui-shared/Forms/CatalogItemBaseForm'
import KToolTip from 'ui-shared/KTooltip'
import SingleImageInput from 'ui-shared/WrappedInputs/SingleImageInput'

const LocationFeatureForm: React.FC<CatalogItemBaseFormProps> = (props) => {
  return (
    <CatalogItemBaseForm {...props}>
      <KToolTip title="tooltip.hint.locationFeatureImage">
        <SingleImageInput accept=".png" />
      </KToolTip>
      <SelectInput
        source="category"
        choices={locationFeatureCategoryChoices}
        validate={required()}
      />
    </CatalogItemBaseForm>
  )
}

export default LocationFeatureForm
